import http from "@/plugins/Axios";
import { trueSet } from "@/utils/pureFunctions";

export default {
  actions: {
    async getColumns(_, table) {
      try {
        const {
          data: { data },
        } = await http.get("column-settings/columns", {
          params: { table },
        });
        return Promise.resolve(
          data.map((item) => {
            item.sortable = trueSet(item.sortable);
            item.custom = trueSet(item.custom);
            item.visible = trueSet(item.visible);
            return item;
          })
        );
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async updateColumn(_, { columnName, visible, table }) {
      try {
        const {
          data: { data },
        } = await http.post("column-settings/update", {
          columnName,
          visible,
          table,
        });
        return Promise.resolve(data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
